export default "__VITE_ASSET__BA7QUGNr__"